const paths: string[] = [
    require('./everyday_digital_and_weekend_papers_june23.webp'),
    require('./everyday_digital_may_2024.webp'),
    require('./everyday_digital_weekend_papers_may_2024.webp'),
    require('./everyday_digital_and_weekend_papers_cropped.webp'),
    require('./everyday_digital_and_weekend_papers.webp'),
    require('./everyday_digital_june23.webp'),
    require('./everyday_digital_cropped.webp'),
    require('./everyday_digital.webp'),
    require('./mon-sat_and_everyday_digital_cropped.webp'),
    require('./mon-sat_and_everyday_digital.webp'),
    require('./mon-sun_and_everyday_digital_cropped.webp'),
    require('./mon-sun_and_everyday_digital.webp'),
    require('./sunday_times_cropped.webp'),
    require('./sunday_times.webp'),
    require('./twa_sat_cropped.webp'),
    require('./twa_sat.webp'),
    require('./weekend_cropped.webp'),
    require('./weekend.webp'),
    // Footy pack images
    require('./everyday_digital_weekend_papers_footy2024.webp'),
    require('./everyday_digital_footy2024.webp'),
    require('./mon_sat_everyday_digital_footy2024.webp'),
    require('./mon_sun_everyday_digital_footy2024.webp'),
    require('./weekend_papers_footy2024.webp'),
    require('./sunday_times_footy2024.webp'),
    require('./saturday_west_footy2024.webp'),
]

const mobilePaths: string[] = [
    require('./mobile/everyday_digital_and_weekend_papers_june23.webp'),
    require('./mobile/everyday_digital_may_2024.webp'),
    require('./mobile/everyday_digital_weekend_papers_may_2024.webp'),
    require('./mobile/everyday_digital_and_weekend_papers_cropped.webp'),
    require('./mobile/everyday_digital_and_weekend_papers.webp'),
    require('./mobile/everyday_digital_june23.webp'),
    require('./mobile/everyday_digital_cropped.webp'),
    require('./mobile/everyday_digital.webp'),
    require('./mobile/mon-sat_and_everyday_digital_cropped.webp'),
    require('./mobile/mon-sat_and_everyday_digital.webp'),
    require('./mobile/mon-sun_and_everyday_digital_cropped.webp'),
    require('./mobile/mon-sun_and_everyday_digital.webp'),
    require('./mobile/sunday_times_cropped.webp'),
    require('./mobile/sunday_times.webp'),
    require('./mobile/twa_sat_cropped.webp'),
    require('./mobile/twa_sat.webp'),
    require('./mobile/weekend_cropped.webp'),
    require('./mobile/weekend.webp'),
    // Footy pack images
    require('./mobile/everyday_digital_weekend_papers_footy2024.webp'),
    require('./mobile/everyday_digital_footy2024.webp'),
    require('./mobile/mon_sat_everyday_digital_footy2024.webp'),
    require('./mobile/mon_sun_everyday_digital_footy2024.webp'),
    require('./mobile/weekend_papers_footy2024.webp'),
    require('./mobile/sunday_times_footy2024.webp'),
    require('./mobile/saturday_west_footy2024.webp'),
]

export const packageImages: { [imageName: string]: string } = {}
for (let i = 0; i < paths.length; i++) {
    const path = paths[i]
    const fileName = path
        .substring(path.lastIndexOf('/') + 1)
        .replace(/\..*\.webp/, '.webp')
    packageImages[fileName] = path
    const mobilePath = mobilePaths[i]
    packageImages['mobile/' + fileName] = mobilePath
}
